// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app__error":"App_app__error__YFaay"};